export const apiUrl = ' https://amarant.herokuapp.com'
export const MAPBOX_API_KEY = 'pk.eyJ1IjoiaW9ua28iLCJhIjoiY2wwcnQzd205MDUxZDNqczBtZ2YxeXdhNSJ9.obIklcld90kwyuwcNNSWjA'
